import * as React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { match } from "react-router-dom"; //needed for 'location' object and 'match.params'
import { mapDispatchToProps, updateReduxAction } from "../../redux/actions";
import "../../css/FactoryRequests.scss";
import DesignInputs from "./DesignInputs";
import SubmittalInputs from "./SubmittalInputs";
import Modifications from "./Modifications";
import { createFactoryRequest, getFactoryRequestLogData, getUnits, updateProjectInDatabase } from "../../api-calls/projectDataService";
import { isEmptyArray, resetReduxModals } from "../../utilities/helpers";
import { addNotification } from "../../api-utilities/notification-tools";
import FactoryRequestLog from "./FactoryRequestLog";
import Release from "./Release";
import {
  allowedFileExtensions,
  FACTORY_REQUEST_EMAIL_VALIDATION_MESSAGE,
  formatDate,
  hasRestrictedFactoryRequestEmail,
  needsRecalc,
  showNeedsRecalcModal
} from "./FactoryRequestUtility";
import { getSelectedProject } from "../Project/ProjectUtilities";
import { updateMultipleUnitPricing } from "../../api-calls/pricingDataService";

// expected props
interface IProps {
  updateRedux: any;
  match: match<any>;
  reduxFactoryRequest:any;
  reduxMenus:any;
  reduxModals:any;
  reduxFactoryModifications:any;
  reduxFactoryDesignDetails:any;
  reduxFactorySubmittalDetails:any;
  reduxFactoryRequestUnits:any;
  reduxFactoryRequestLog:any[];
  reduxProjectManagement:any;
}
// local state
interface IState {
  disableUI:boolean;
  requestModificationFile: File[] | null;
  modificationMissing:boolean;
  design_pricingMissing:boolean;
  design_basisOfDesignMissing:boolean;
  submittal_purchaseOrderNumberMissing:boolean;
  submittal_selectedUnitsMissing:boolean;
  showSubmitTooltip:boolean;
  disableRequestType:boolean;
}
class FactoryRequestMain extends React.Component<IProps, IState> {

  public state: IState = {
    disableUI:false,
    requestModificationFile: [] as File[],
    modificationMissing:false,
    design_pricingMissing:false,
    design_basisOfDesignMissing:false,
    submittal_purchaseOrderNumberMissing:false,
    submittal_selectedUnitsMissing:false,
    showSubmitTooltip:false,
    disableRequestType:false

  };
  async componentDidMount() {
    this.clearReduxDefaults();
    this.props.updateRedux("UPDATE_MENUS", { topMenu: { activeItem: 7 } });
    const { projectId, unitId } = this.props.match.params;
    const routeProjectId = "proj-" + projectId;
    
    //Protect against refresh on this page.  Need to repopulate reduxProjectManagement if refresh occurs.
    //Also reload when navigating here from another project's release modal.
    if (this.props.reduxProjectManagement.selectedProject?.id !== routeProjectId){
      await getSelectedProject(routeProjectId);
    }
    //Get list of units for this project and store in redux.
    const response = await getUnits(routeProjectId);
    const unitList = response.unitList != null ? response.unitList : [];
    store.dispatch(updateReduxAction("UPDATE_FACTORY_REQUEST_UNITS", unitList));

    //Save the projectId in redux.
    this.updateFactoryRequestInRedux("ProjectId", routeProjectId);

    //Get prior factory requests to show in the log.
    await this.getFactoryRequestLogData();

    await this.runPricing();
  }
  runPricing = async () => {
    //unitList is used to get the UnitTags
    const unitList = (store.getState() as any).reduxFactoryRequestUnits;
    const unitIds: string[] = unitList.map((u:any) => u.id);

    const { projectId, unitId } = this.props.match.params;
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });

    let priceResponse = await updateMultipleUnitPricing(projectId, unitIds);
    
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });

    if (priceResponse.individualErrors.length > 0){
      const hasIndividualErrors = !isEmptyArray(priceResponse.individualErrors);

      const notification = {
        id: "updateMultiplePricing",
        notificationType: "error",
        title: hasIndividualErrors ? "Pricing Errors" : "Pricing Error",
        content: (
          <div className="nf-div">
            {hasIndividualErrors
              ? priceResponse.individualErrors.toString()
              : priceResponse.errorMessage?.toString()}
          </div>
        )
      };
      addNotification(notification);
    }
    if (priceResponse.calcErrorUnits && priceResponse.calcErrorUnits.length > 0){
      this.props.updateRedux("UPDATE_FACTORY_REQUEST_BAD_UNITS", priceResponse.calcErrorUnits );
    }
    else {
      this.props.updateRedux("UPDATE_FACTORY_REQUEST_BAD_UNITS", [] );
    }
  }
  private clearReduxDefaults(){
    const designDetails = this.props.reduxFactoryDesignDetails;
    let designDetailsCopy = { ...designDetails };
    designDetailsCopy.designRequestDetails["Pricing"]= "";
    designDetailsCopy.designRequestDetails["AdditionalEmailRecipients"] = [];
    this.props.updateRedux("UPDATE_DESIGN_DETAILS", designDetailsCopy );

    const submittalDetails = this.props.reduxFactorySubmittalDetails;
    let submittalDetailsCopy = { ...submittalDetails };
    submittalDetailsCopy.submittalRequestDetails["AdditionalEmailRecipients"]= [];
    this.props.updateRedux("UPDATE_SUBMITTAL_DETAILS", submittalDetailsCopy );

    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: []});
    this.setState({requestModificationFile: []});

    this.updateFactoryRequestInRedux("RequestType", "Design");
    this.updateFactoryRequestInRedux("RequestId", null);
  }
  componentDidUpdate(prevProps: IProps){
    const modal = this.props.reduxModals;

    //If submittal modal state changed from open to closed
    if (prevProps.reduxModals.showModal !== modal.showModal && modal.showModal === false) {
      //If the modal that just closed was the 'submit-factory-request' modal, and the user response was 'ok'
      if (modal.modalId === 'submit-factory-request' && modal.userResponse === 'ok') {
        this.setState({disableRequestType:false});
        this.submitFactoryRequest();
      }
      //Only reset the modal if the id is 'submit-factory-request'
      if (modal.modalId === 'submit-factory-request') {
        resetReduxModals();
      }
      
    }
  }
  private getFactoryRequestLogData = async () => {
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });
    const { projectId, unitId } = this.props.match.params;
    
    const result = await getFactoryRequestLogData("proj-" + projectId);
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });
 
    if (result && result.factoryRequests.length > 0) {
      this.props.updateRedux("UPDATE_FACTORY_REQUEST_LOG", result.factoryRequests);

      //Pre-populate email recipients for design and submittal details based on the most recent request in the log.
      const lastRequest = result.factoryRequests[0];
      let priorRecipients = [];
      if(lastRequest.requestType === "Design"){
        priorRecipients = lastRequest.designRequestDetails?.additionalEmailRecipients ? lastRequest.designRequestDetails.additionalEmailRecipients.split(",") : [];
      }else if(lastRequest.requestType === "Submittal"){
        priorRecipients = lastRequest.submittalRequestDetails?.additionalEmailRecipients ? lastRequest.submittalRequestDetails.additionalEmailRecipients.split(",") : [];
      }

      //Design store
      const designCopy = { ...this.props.reduxFactoryDesignDetails };
      designCopy.designRequestDetails["AdditionalEmailRecipients"] = priorRecipients;
      this.props.updateRedux("UPDATE_DESIGN_DETAILS", designCopy);

      //Submittal store
      const submittalCopy = { ...this.props.reduxFactorySubmittalDetails };
      submittalCopy.submittalRequestDetails["AdditionalEmailRecipients"] = priorRecipients;
      this.props.updateRedux("UPDATE_SUBMITTAL_DETAILS", submittalCopy);
    }
    else {
      this.props.updateRedux("UPDATE_FACTORY_REQUEST_LOG", []);
    }
    if (result.hasError) {//TODO:Test this
      const notification = {
        id: "getFactoryRequestLogData",
        notificationType: "error",
        title: "Error",
        content: <div className="nf-div">getFactoryRequestLogData {result.errorMessage}</div>
      };
      addNotification(notification);
    }
    this.checkLogStatuses();
  }
  private checkLogStatuses(){
    //If there are any factory requests that are not complete(5) or cancelled(6),
    //then disable the UI.
    const requestLogs = this.props.reduxFactoryRequestLog;
    
    const hasAnyInProgress = requestLogs.some((log:any) => 
      (log.statusId !== 5 && log.statusId !== 6) || log.requestType === "Release" 
    );
    this.setState({disableUI: hasAnyInProgress});
  }
  private modifyLogRequest = (requestId:number) => {
    const logs = this.props.reduxFactoryRequestLog;

    const logToModify:any = logs.find(
      (l: any) => l.requestId === requestId
    );

    if (!logToModify) return;

    this.setState({disableRequestType:true});
    // --- Base Factory Request ---
    const factoryRequest = {
      factoryRequest: {
        RequestType: logToModify.requestType,
        ProjectId: logToModify.projectId,
        RequestId: logToModify.requestId,
        SelectedUnits: logToModify.selectedUnits.map((u: any) => u.unitId)
      },
    };
    // --- Design Details ---
    const designRequestDetails =
       logToModify.requestType === "Design"
        ? 
        {
            designRequestDetails: {
              Pricing: logToModify.designRequestDetails?.pricing,
              BasisOfDesign: logToModify.designRequestDetails?.basisOfDesign,
              BidDate: logToModify.designRequestDetails?.bidDate ?? null,
              AdditionalEmailRecipients:
                logToModify.designRequestDetails?.additionalEmailRecipients ? logToModify.designRequestDetails.additionalEmailRecipients.split(",").filter((email: string) => email.trim() !== "") : [],
            },
         }
        : { designRequestDetails: {BidDate: formatDate(new Date())}};

    // --- Submittal Details ---
    const submittalRequestDetails =
      logToModify.requestType === "Submittal"
        ? 
        {
            submittalRequestDetails: {
              PurchaseOrderNumber:
                logToModify.submittalRequestDetails?.purchaseOrderNumber,
              ConsultingEngineer:
                logToModify.submittalRequestDetails?.consultingEngineer,
              Contractor: logToModify.submittalRequestDetails?.contractor,
              AdditionalEmailRecipients:
                logToModify.submittalRequestDetails?.additionalEmailRecipients ? logToModify.submittalRequestDetails.additionalEmailRecipients.split(",").filter((email: string) => email.trim() !== "") : [],
            },
        }
        : { submittalRequestDetails: {} };

    // --- Modifications ---
    const modObject = {
      modifications: logToModify.modifications.map((m: any, index:number) => ({
        ModificationType: m.modificationType,
        Description: m.description,
        ModifiedUnits: m.modifiedUnits.map((mu: any) => mu.unitId),
        id: index
      })),
    };

    // --- Remove Log Entry that has moved to Modify ----
    const logsToKeep:any = logs.filter(
      (log: any) => log.requestId !== requestId
    );
    // --- Dispatch ---
    this.props.updateRedux("UPDATE_FACTORY_REQUEST", factoryRequest);
    this.props.updateRedux("UPDATE_DESIGN_DETAILS", designRequestDetails);
    this.props.updateRedux("UPDATE_SUBMITTAL_DETAILS", submittalRequestDetails);
    this.props.updateRedux("UPDATE_MODIFICATIONS", modObject);
    this.props.updateRedux("UPDATE_FACTORY_REQUEST_LOG", logsToKeep);

    this.setState({disableUI:false});
  }
  public render() {
    
    return (
      <div>
        <div className="request-form">
            {/* Request Type */}
            <label className="label-width">Request Type</label>
            <select
              disabled = {this.state.disableRequestType === true}
              value={this.props.reduxFactoryRequest.factoryRequest.RequestType}
              onChange={(e) => this.updateFactoryRequestInRedux("RequestType", e.target.value)}
            >
              <option>Design</option>
              <option>Submittal</option>
              <option>Release</option>
            </select>

            {this.props.reduxFactoryRequest.factoryRequest.RequestType ==="Design" ? (
              <>
              <DesignInputs match={this.props.match} pricingInvalid={this.state.design_pricingMissing} basisOfDesignInvalid={this.state.design_basisOfDesignMissing}/>
              <Modifications disableUI={this.state.disableUI} modificationsInvalid={this.state.modificationMissing} />
              </>
            ) : null}
            {this.props.reduxFactoryRequest.factoryRequest.RequestType ==="Submittal" ? (
              <>
              <SubmittalInputs match={this.props.match} disableUI={this.state.disableUI} purchaseOrderMissing={this.state.submittal_purchaseOrderNumberMissing}
                              selectedUnitsMissing={this.state.submittal_selectedUnitsMissing}/>
              <Modifications disableUI={this.state.disableUI} modificationsInvalid={this.state.modificationMissing}/>
              </>
            ) : null}
          
            {this.props.reduxFactoryRequest.factoryRequest.RequestType ==="Release" ? (
              <Release getLogData={this.getFactoryRequestLogData} match={this.props.match}/>
            ) : null}
            
            {this.props.reduxFactoryRequest.factoryRequest.RequestType === "Design" || this.props.reduxFactoryRequest.factoryRequest.RequestType === "Submittal" ? (
              <div>
                {/* FILE UPLOAD */}
                <div className={this.state.disableUI ? "element-disable button-parent2" : "button-parent2"}>
                    <input
                        type="file"
                        id="fileUpload"
                        multiple
                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.step,.dwg"
                        style={{ display: "none" }}
                        onChange={(e) => this.handleFileChange("requestModificationFile", e)}
                    />
                    <button
                        type="button"
                        onClick={() => document.getElementById("fileUpload")?.click()}
                    >
                      Upload File
                    </button>
                    <div className="file-list">
                      {this.state.requestModificationFile !== null ? (
                        this.state.requestModificationFile.map((file: File, index: number) => (
                          <div key={index} className="file-item">
                              <span className="display-file">{file.name}</span>
                              <button
                                  type="button"
                                  className="delete-button"
                                  disabled={this.state.disableUI} // <-- disable delete
                                  onClick={() => this.removeFile(index)}
                              >
                                  ×
                              </button>
                          </div>
                        ))) : null
                      }
                    </div>
              </div>
              <div className="button-parent">
                {/* Submit Button */}
                <div className="submit-button-wrapper"
                  onMouseEnter={() => this.setState({ showSubmitTooltip: this.showSubmitToolTip() })}
                  onMouseLeave={() => this.setState({ showSubmitTooltip: false })}
                >
                  <button
                    className={"factory-submit-button " + this.getSubmitButtonClass()}
                    onClick={() => this.showSubmitRequestModal()}
                    
                  >
                    Submit
                  </button>
                    {this.state.showSubmitTooltip && (
                      <div className="submit-tooltip">
                        {this.getSubmitToolTipText()}
                      </div>
                    )}
                </div>
              </div>
            </div>
            ) : null}
          </div>
          <FactoryRequestLog getLogData={this.getFactoryRequestLogData} modifyLogRequest={this.modifyLogRequest}/>
        </div>
    );
  }
  private getMissingFieldState() {
    const modifications = this.props.reduxFactoryModifications.modifications;
    const factoryRequest = this.props.reduxFactoryRequest.factoryRequest;
    const designDetails = this.props.reduxFactoryDesignDetails.designRequestDetails;
    const submittalDetails = this.props.reduxFactorySubmittalDetails.submittalRequestDetails;
  
    let state = {
      modificationMissing: false,
      design_pricingMissing: false,
      design_basisOfDesignMissing: false,
      submittal_purchaseOrderNumberMissing: false,
      submittal_selectedUnitsMissing: false
    };
  
    if (factoryRequest.RequestType === "Design" && (!modifications || modifications.length === 0)) {
      state.modificationMissing = true;
    }
  
    const hasIncomplete = modifications?.some((mod: any) =>
      mod.ModificationType === "Select Type" ||
      !mod.ModifiedUnits ||
      mod.ModifiedUnits.length === 0 ||
      mod.Description === ""
    );
  
    if (hasIncomplete) {
      state.modificationMissing = true;
    }
  
    if (factoryRequest.RequestType === "Design") {
      state.design_pricingMissing = designDetails.Pricing === "";
      state.design_basisOfDesignMissing = designDetails.BasisOfDesign === "";
    }
  
    if (factoryRequest.RequestType === "Submittal") {
      state.submittal_purchaseOrderNumberMissing = submittalDetails.PurchaseOrderNumber === "";
      state.submittal_selectedUnitsMissing =
        !factoryRequest.SelectedUnits || factoryRequest.SelectedUnits.length === 0;
    }
  
    return state;
  }

  private showSubmitRequestModal(){
    const mods = this.props.reduxFactoryModifications.modifications;
    const allUnits = this.props.reduxFactoryRequestUnits;
    const recalcUnits = needsRecalc(mods, allUnits);
    if (recalcUnits.length !== 0) {
      showNeedsRecalcModal(recalcUnits);
      return;
    }

    if (this.hasRestrictedAdditionalEmailRecipients()) {
      return;
    }

    const validation = this.getMissingFieldState();

    this.setState(validation);

    const requestType = this.props.reduxFactoryRequest.factoryRequest?.RequestType;

    if (
      (requestType === "Design" &&
      !validation.design_basisOfDesignMissing &&
      !validation.design_pricingMissing &&
      !validation.modificationMissing)

      ||

      (requestType === "Submittal" &&
      !validation.modificationMissing &&
      !validation.submittal_purchaseOrderNumberMissing &&
      !validation.submittal_selectedUnitsMissing)
      ){

      const modalData = {
        title: 'Confirm',
        content: <div>
          <p>By submitting this request, Innovent Engineering will review the proposed factory custom modifications.</p>
          <p>If approved, engineering will make the required changes to the unit design(s). During this process:</p>
          <ul>
            <li className="modal-list-item">The selected unit(s) will be <b>locked in SpecMate</b></li>
            <li className="modal-list-item"><b>No design changes</b> will be allowed</li>
            <li className="modal-list-item"><b>Additional modification requests cannot be submitted</b> until this request is completed or cancelled</li>
          </ul>
          </div>
      };
      this.props.updateRedux('UPDATE_MODALS', {
        showModal: true,
        modalType: 'ModalPopup',
        modalId: 'submit-factory-request',
        modalData: modalData,
        hideCancelBtn: false
      });
    }
  }
  private getSubmitToolTipText(){
    const log = this.props.reduxFactoryRequestLog;
    //If a release request has been submitted, never allow the submit button to be enabled.
    const releaseCount = log.filter(item => item?.requestType === "Release").length;
    if (releaseCount > 0){
      return `This project has been released and modification requests are no longer allowed. 
      For change orders or cancellations to the project, please contact your RSM.`;
    }
    const hasAnyInProgress = log.some((log:any) => 
      (log.statusId !== 5 && log.statusId !== 6) 
    );
    if (hasAnyInProgress){
      return `Submit is unavailable until the previous modification request is completed or canceled.`;
    }
  }
  private showSubmitToolTip(){
    const log = this.props.reduxFactoryRequestLog;

    return log.some((item: any) =>
      item?.requestType === "Release" ||
      (item.statusId !== 5 && item.statusId !== 6)
    );
  }
  private getSubmitButtonClass(){
    const log = this.props.reduxFactoryRequestLog;
    //If a release request has been submitted, never allow the submit button to be enabled.
    const releaseCount = log.filter(item => item?.requestType === "Release").length;
    return this.state.disableUI || releaseCount > 0 ? "element-disable" : "";
  }
  private hasMissingTags(){
    //find will return the first matching item.
    const matchingUnit = this.props.reduxFactoryRequestUnits.find(
      (unit:any) => unit.unitQuantity > 1 && unit.unitTagMultiple === null && unit.isActive === true
    );
    if (matchingUnit){
      const notification = {
        id: "unitTagMultipleError",
        notificationType: "warning",
        title: "Warning",
        content: <div className="nf-div">Unit {matchingUnit.id} ({matchingUnit.unitTag}) has a quantity greater than 1 and is missing unit tags.
          Please update the unit tags by going to Job Files tab and clicking the “tags” link (next to Copy/Delete) in the unit row</div>
      };
      addNotification(notification);
      return true;
    }
    else {
      return false;
    }
  }
  private hasRestrictedAdditionalEmailRecipients(){
    const requestType = this.props.reduxFactoryRequest.factoryRequest?.RequestType;
    const additionalEmailRecipients = requestType === "Design"
      ? this.props.reduxFactoryDesignDetails.designRequestDetails?.AdditionalEmailRecipients
      : requestType === "Submittal"
        ? this.props.reduxFactorySubmittalDetails.submittalRequestDetails?.AdditionalEmailRecipients
        : [];

    if (hasRestrictedFactoryRequestEmail(additionalEmailRecipients)) {
      addNotification({
        id: "factoryRequestRestrictedEmail",
        notificationType: "error",
        title: "Invalid Email Address",
        content: <div className="nf-div">{FACTORY_REQUEST_EMAIL_VALIDATION_MESSAGE}</div>
      });
      return true;
    }

    return false;
  }
  private async submitFactoryRequest(){
    if (this.hasRestrictedAdditionalEmailRecipients()){
      return;
    }

    if (this.hasMissingTags()){
      return;
    }

    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });
    const designRequestDetails = this.props.reduxFactoryDesignDetails.designRequestDetails;
    const submittalRequestDetails = this.props.reduxFactorySubmittalDetails.submittalRequestDetails;

    //unitList is used to get the UnitTags and OpportunityProductId
    const unitList = this.props.reduxFactoryRequestUnits;

    //Create an object for each unit selected to include the unitId, unitTag, and opportunityProductId
    const modifications = this.convertModifiedUnits(
      this.props.reduxFactoryModifications.modifications,
      unitList
    );
    let units = this.convertUnits(
      this.props.reduxFactoryRequest.factoryRequest.SelectedUnits,
      unitList
    );
    let requestObject = {
      ProjectId: this.props.reduxFactoryRequest.factoryRequest.ProjectId,
      RequestType: this.props.reduxFactoryRequest.factoryRequest.RequestType,
      RequestId: this.props.reduxFactoryRequest.factoryRequest.RequestId,
      DesignRequestDetails: {
        Pricing: designRequestDetails?.Pricing ?? "",
        BasisOfDesign: designRequestDetails?.BasisOfDesign ?? "",
        BidDate: designRequestDetails?.BidDate ?? "",
        //trim() removes leading/trailing spaces
        ///\s+/ splits on one or more whitespace characters
        //join(",") puts it back together with commas
        AdditionalEmailRecipients: designRequestDetails?.AdditionalEmailRecipients ? 
                designRequestDetails?.AdditionalEmailRecipients.join(",") : "",
      },
      SubmittalRequestDetails: {
        PurchaseOrderNumber: submittalRequestDetails?.PurchaseOrderNumber ?? "",
        ConsultingEngineer: submittalRequestDetails?.ConsultingEngineer ?? "",
        Contractor: submittalRequestDetails?.Contractor ?? "",
        AdditionalEmailRecipients: submittalRequestDetails?.AdditionalEmailRecipients ? 
              submittalRequestDetails?.AdditionalEmailRecipients.join(",") : "",
      },
      SelectedUnits:units,
      Modifications: modifications
    }
    //Update project information fields.
    await this.updateProjectInfo();

    const factoryRequestResponse = await createFactoryRequest(requestObject, this.state.requestModificationFile, null, null);

    if (factoryRequestResponse.success) {
        //1. Clear redux of current request.
        this.clearReduxDefaults();
        //2. Call get all requests to update log.
        this.getFactoryRequestLogData();
    }

    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });
}
private async updateProjectInfo(){
  const submittalDetails = this.props.reduxFactorySubmittalDetails;
  const designDetails = this.props.reduxFactoryDesignDetails;

  let selectedProject = { ...this.props.reduxProjectManagement.selectedProject};
  selectedProject.designBasis = designDetails.designRequestDetails.BasisOfDesign;
  selectedProject.contractor = submittalDetails.submittalRequestDetails.Contractor ? submittalDetails.submittalRequestDetails.Contractor : 
                                this.props.reduxProjectManagement.selectedProject.contractor;
  selectedProject.consultingEngineer = submittalDetails.submittalRequestDetails.ConsultingEngineer ? submittalDetails.submittalRequestDetails.ConsultingEngineer :
                                this.props.reduxProjectManagement.selectedProject.consultingEngineer;
  selectedProject.purchaseOrderNumber = submittalDetails.submittalRequestDetails.PurchaseOrderNumber ? submittalDetails.submittalRequestDetails.PurchaseOrderNumber :
                                this.props.reduxProjectManagement.selectedProject.purchaseOrderNumber;

  this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {selectedProject: selectedProject});
  //Call the project data service method to update project data.
  await updateProjectInDatabase(selectedProject);    
}
  //This builds a lookup table using the unitList in reduxProjectManagement.  It uses the unitId to find the unitTag.
  //May need to add to this for OpportunityProductId
  private buildUnitLookup(unitList: any[]) {
    return unitList.reduce(
      (acc: Record<string, { unitTag: string; opportunityProductId: string }>, unit: any) => {
        acc[unit.id] = {
          unitTag: unit.unitTag,
          opportunityProductId: unit.crmOpportunityProductId
        };
        return acc;
      },
      {}
    );
  }
  //SelectedUnits is an array of unit Ids.  We need to convert this array to include a unitId, UnitTag, and
  //opportunityProductId property for each item.  If the user selected "All" units, then every unit in the project would be included.
  private convertUnits(SelectedUnits:any[], unitList: any[]) {
    const unitLookup = this.buildUnitLookup(unitList);
  
    let units = SelectedUnits;
    const includesAll = units.includes("All");

    let convertedUnits;

    if (includesAll) {
      // Include every unit from the lookup
      convertedUnits = Object.keys(unitLookup).map(unitId => ({
        UnitId: unitId,
        UnitTag: unitLookup[unitId]?.unitTag || null,
        OpportunityProductId: unitLookup[unitId]?.opportunityProductId || null
      }));
    } else {
      convertedUnits = units.map((unitId: string) => ({
        UnitId: unitId,
        UnitTag: unitLookup[unitId]?.unitTag || null,
        OpportunityProductId: unitLookup[unitId]?.opportunityProductId || null
      }));
    }

    return convertedUnits;
  }
  //modifications is an array of modifications that each contain a list of unit Ids.
  private convertModifiedUnits(modifications: any[], unitList: any[]) {
    const unitLookup = this.buildUnitLookup(unitList);
  
    return modifications.map(mod => {
      const includesAll = mod.ModifiedUnits.includes("All");
  
      let convertedUnits;
  
      if (includesAll) {
        // Include every unit from the lookup
        convertedUnits = Object.keys(unitLookup).map(unitId => ({
          UnitId: unitId,
          UnitTag: unitLookup[unitId]?.unitTag || null,
          OpportunityProductId: unitLookup[unitId]?.opportunityProductId || null
        }));
      } else {
        convertedUnits = mod.ModifiedUnits.map((unitId: string) => ({
          UnitId: unitId,
          UnitTag: unitLookup[unitId]?.unitTag || null,
          OpportunityProductId: unitLookup[unitId]?.opportunityProductId || null
        }));
      }
  
      return {
        ...mod,
        ModifiedUnits: convertedUnits
      };
    });
  }
  //Save user selection.
  private updateFactoryRequestInRedux(fieldName:string, value:any){
    const factoryRequest = this.props.reduxFactoryRequest;
    let factoryRequestCopy = { ...factoryRequest };
    factoryRequestCopy.factoryRequest[fieldName]= value;
    factoryRequestCopy.factoryRequest["SelectedUnits"] = []; //clear out selected units when request type changes.
    this.props.updateRedux("UPDATE_FACTORY_REQUEST", factoryRequestCopy );
  }
  //FILE ACTIONS
  private handleFileChange = (stateName: keyof IState, e: React.ChangeEvent<HTMLInputElement>) => {
    if (this.state.disableUI) return;

    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
  
      const validFiles: File[] = [];
      const invalidFiles: File[] = [];
  
      newFiles.forEach(file => {
        const extension = "." + file.name.split(".").pop()?.toLowerCase();
  
        if (allowedFileExtensions.includes(extension)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file);
        }
      });
  
      // show invalid files to user
      if (invalidFiles.length > 0) {

        const notification = {
          id: "invalidfiletype",
          notificationType: "warning",
          title: "Invalid File Type",
          content: <div className="nf-div">These files are not allowed. {invalidFiles.map(f => f.name).join(", ")}.  Allowed Types({allowedFileExtensions.join(", ")})</div>
        };
        addNotification(notification);
      }
  
      // save only valid files
      if (validFiles.length > 0) {
        this.setState((prevState) => ({
          ...prevState,
          [stateName]: [
            ...(prevState[stateName] as File[]),
            ...validFiles
          ]
        }));
      }
    }
  }
  private removeFile = (index: number) => {
    this.setState((prevState: any) => {
        const files = [...prevState.requestModificationFile];
        files.splice(index, 1); // remove the file at index
        return { requestModificationFile: files };
    });
};
}
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxFactoryRequest: state.reduxFactoryRequest,
    reduxFactoryModifications: state.reduxFactoryModifications,
    reduxFactoryDesignDetails: state.reduxFactoryDesignDetails,
    reduxFactorySubmittalDetails: state.reduxFactorySubmittalDetails,
    reduxFactoryRequestLog: state.reduxFactoryRequestLog,
    reduxFactoryRequestUnits: state.reduxFactoryRequestUnits,
    reduxMenus: state.reduxMenus,
    reduxModals: state.reduxModals,
    reduxProjectManagement: state.reduxProjectManagement
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(FactoryRequestMain);
